import React, { useState, useEffect } from 'react';
import Toggle from '../../../Common/Toggle/Toggle';
import { FaEdit, FaTrash, FaPlus, FaSearch, FaSave, FaTimes } from 'react-icons/fa';
import '../Nucleos/Nucleos.css';

import API_BASE_URL from '../../../../config/api';

const ClassificacaoEnquadramento = () => {
  const [classificacoesEnquadramento, setClassificacoesEnquadramento] = useState([]);
  const [orgaos, setOrgaos] = useState([]);
  const [showForm, setShowForm] = useState(false);
  const [editingId, setEditingId] = useState(null);
  const [searchTerm, setSearchTerm] = useState('');
  const [formData, setFormData] = useState({
    classificacao_enquadramento: '',
    sigla: '',
    id_orgao: '',
    ativo: true
  });
  const [loading, setLoading] = useState(false);
  const [saving, setSaving] = useState(false);

  const carregarClassificacoes = async () => {
    setLoading(true);
    try {
      const response = await fetch(
        `${API_BASE_URL}/classificacao-enquadramento`
      );

      if (!response.ok) {
        throw new Error('Erro ao buscar classificações de enquadramento');
      }

      const data = await response.json();

      const formatadas = data.map((item) => ({
        id: item.id_classificacao_enquadramento,
        classificacao_enquadramento: item.nome_classificacao_enquadramento,
        sigla: item.sigla || '',
        id_orgao: item.id_orgao ? String(item.id_orgao) : '',
        orgao_referencia: item.orgao_referencia || '',
        ativo: item.ativo
      }));

      setClassificacoesEnquadramento(formatadas);
    } catch (error) {
      console.error('Erro ao carregar classificações de enquadramento:', error);
      alert(
        'Erro ao carregar classificações de enquadramento. Verifique a conexão com o servidor.'
      );
    } finally {
      setLoading(false);
    }
  };

  const carregarOrgaos = async () => {
    try {
      const response = await fetch(`${API_BASE_URL}/orgaos-referencia`);

      if (!response.ok) {
        throw new Error('Erro ao buscar órgão de referência');
      }

      const data = await response.json();
      setOrgaos(data);
    } catch (error) {
      console.error('Erro ao carregar órgão de referência:', error);
      setOrgaos([]);
    }
  };

  useEffect(() => {
    carregarClassificacoes();
    carregarOrgaos();
  }, []);

  const filteredClassificacoesEnquadramento = classificacoesEnquadramento.filter(classificacao =>
    classificacao &&
    `${classificacao.classificacao_enquadramento} ${classificacao.sigla} ${classificacao.orgao_referencia}`
      .toLowerCase()
      .includes((searchTerm || '').toLowerCase())
  );

  const handleSubmit = async (e) => {
    e.preventDefault();
    setSaving(true);

    try {
      const payload = {
        nome_classificacao_enquadramento: formData.classificacao_enquadramento,
        sigla: formData.sigla || null,
        id_orgao: formData.id_orgao ? Number(formData.id_orgao) : null,
        ativo: formData.ativo
      };

      if (editingId) {
        const response = await fetch(
          `${API_BASE_URL}/classificacao-enquadramento/${editingId}`,
          {
            method: 'PUT',
            headers: {
              'Content-Type': 'application/json'
            },
            body: JSON.stringify(payload)
          }
        );

        if (!response.ok) {
          throw new Error('Erro ao atualizar classificação de enquadramento');
        }

        const atualizado = await response.json();

        setClassificacoesEnquadramento((prev) =>
          prev.map((classificacao) =>
            classificacao.id === editingId
              ? {
                  id: atualizado.id_classificacao_enquadramento,
                  classificacao_enquadramento:
                    atualizado.nome_classificacao_enquadramento,
                  sigla: atualizado.sigla || '',
                  id_orgao: atualizado.id_orgao ? String(atualizado.id_orgao) : '',
                  orgao_referencia: atualizado.orgao_referencia || '',
                  ativo: atualizado.ativo
                }
              : classificacao
          )
        );
      } else {
        const response = await fetch(
          `${API_BASE_URL}/classificacao-enquadramento`,
          {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json'
            },
            body: JSON.stringify(payload)
          }
        );

        if (!response.ok) {
          throw new Error('Erro ao criar classificação de enquadramento');
        }

        const criado = await response.json();

        setClassificacoesEnquadramento((prev) => [
          ...prev,
          {
            id: criado.id_classificacao_enquadramento,
            classificacao_enquadramento:
              criado.nome_classificacao_enquadramento,
            sigla: criado.sigla || '',
            id_orgao: criado.id_orgao ? String(criado.id_orgao) : '',
            orgao_referencia: criado.orgao_referencia || '',
            ativo: criado.ativo
          }
        ]);
      }

      resetForm();
    } catch (error) {
      console.error('Erro ao salvar classificação de enquadramento:', error);
      alert(
        'Erro ao salvar classificação de enquadramento. Verifique os dados e tente novamente.'
      );
    } finally {
      setSaving(false);
    }
  };

  const handleEdit = (classificacao) => {
    setFormData({
      classificacao_enquadramento: classificacao.classificacao_enquadramento,
      sigla: classificacao.sigla || '',
      id_orgao: classificacao.id_orgao ? String(classificacao.id_orgao) : '',
      ativo: classificacao.ativo
    });
    setEditingId(classificacao.id);
    setShowForm(true);
  };

  const handleDelete = async (id) => {
    if (
      !window.confirm(
        'Tem certeza que deseja excluir esta classificação de enquadramento?'
      )
    ) {
      return;
    }

    try {
      const response = await fetch(
        `${API_BASE_URL}/classificacao-enquadramento/${id}`,
        {
          method: 'DELETE'
        }
      );

      if (!response.ok && response.status !== 204) {
        throw new Error('Erro ao excluir classificação de enquadramento');
      }

      setClassificacoesEnquadramento((prev) =>
        prev.filter((classificacao) => classificacao.id !== id)
      );
    } catch (error) {
      console.error('Erro ao excluir classificação de enquadramento:', error);
      alert(
        'Erro ao excluir classificação de enquadramento. Tente novamente.'
      );
    }
  };

  const resetForm = () => {
    setFormData({
      classificacao_enquadramento: '',
      sigla: '',
      id_orgao: '',
      ativo: true
    });
    setEditingId(null);
    setShowForm(false);
  };

  const handleToggleStatus = async (id) => {
    const classificacaoSelecionada = classificacoesEnquadramento.find(
      (classificacao) => classificacao.id === id
    );

    if (!classificacaoSelecionada) {
      return;
    }

    const novoAtivo = !classificacaoSelecionada.ativo;

    try {
      const response = await fetch(
        `${API_BASE_URL}/classificacao-enquadramento/${id}`,
        {
          method: 'PUT',
          headers: {
            'Content-Type': 'application/json'
          },
          body: JSON.stringify({
            nome_classificacao_enquadramento:
              classificacaoSelecionada.classificacao_enquadramento,
            sigla: classificacaoSelecionada.sigla,
            id_orgao: classificacaoSelecionada.id_orgao
              ? Number(classificacaoSelecionada.id_orgao)
              : null,
            ativo: novoAtivo
          })
        }
      );

      if (!response.ok) {
        throw new Error('Erro ao atualizar status da classificação');
      }

      const atualizado = await response.json();

      setClassificacoesEnquadramento((prev) =>
        prev.map((classificacao) =>
          classificacao.id === id
            ? { ...classificacao, ativo: atualizado.ativo }
            : classificacao
        )
      );
    } catch (error) {
      console.error(
        'Erro ao atualizar status da classificação de enquadramento:',
        error
      );
      alert(
        'Erro ao atualizar status da classificação de enquadramento. Tente novamente.'
      );
    }
  };

  return (
    <div className="nucleos-container">
      <div className="tabela-header">
        <div className="header-content">
          <h1>Classificação Enquadramento</h1>
        </div>
      </div>

      {showForm ? (
        <div className="form-container inline-form">
          <div className="form-header">
            <h2>{editingId ? 'Editar Classificação Enquadramento' : 'Cadastrar Classificação Enquadramento'}</h2>
          </div>
          
          <form onSubmit={handleSubmit} className="form-content">
            <div className="form-group">
              <label htmlFor="classificacao_enquadramento">Classificação Enquadramento *</label>
              <input
                type="text"
                id="classificacao_enquadramento"
                value={formData.classificacao_enquadramento}
                onChange={(e) => setFormData({...formData, classificacao_enquadramento: e.target.value})}
                required
                maxLength={100}
                placeholder="Digite a classificação de enquadramento"
              />
            </div>

            <div className="form-group">
              <Toggle
                id="ativo"
                label="Status:"
                checked={formData.ativo}
                onChange={(e) => setFormData({...formData, ativo: e.target.checked})}
              />
            </div>

            <div className="form-row">
              <div className="form-group">
                <label htmlFor="id_orgao">REF (Órgão de Referência)</label>
                <select
                  id="id_orgao"
                  value={formData.id_orgao}
                  onChange={(e) => {
                    const selectedId = e.target.value;
                    const selectedOrgao = orgaos.find(
                      (o) => String(o.id_orgao_referencia) === String(selectedId)
                    );

                    setFormData((prev) => ({
                      ...prev,
                      id_orgao: selectedId,
                      sigla: selectedOrgao?.sigla || prev.sigla
                    }));
                  }}
                >
                  <option value="">Selecione um órgão de referência</option>
                  {orgaos.map((orgao) => (
                    <option
                      key={orgao.id_orgao_referencia}
                      value={orgao.id_orgao_referencia}
                    >
                      {orgao.nome_orgao_referencia}
                    </option>
                  ))}
                </select>
              </div>

              <div className="form-group">
                <label htmlFor="sigla">Sigla</label>
                <input
                  type="text"
                  id="sigla"
                  value={formData.sigla}
                  onChange={(e) =>
                    setFormData({ ...formData, sigla: e.target.value })
                  }
                  maxLength={20}
                  placeholder="Ex: LP"
                />
              </div>
            </div>

            <div className="form-actions">
              <button type="button" className="btn-secondary" onClick={resetForm}>
                <FaTimes /> Cancelar
              </button>
              <button type="submit" className="btn-primary">
                <FaSave /> {editingId ? 'Atualizar' : 'Cadastrar'}
              </button>
            </div>
          </form>
        </div>
      ) : (
        <div className="table-container">
          <div className="table-controls">
            <div className="search-container">
              <FaSearch />
              <input
                type="text"
                placeholder="Pesquisar classificações de enquadramento..."
                value={searchTerm}
                onChange={(e) => setSearchTerm(e.target.value)}
              />
            </div>
            <div className="table-info">
              <span>
                {loading
                  ? 'Carregando classificações de enquadramento...'
                  : `${filteredClassificacoesEnquadramento.length} registro(s) encontrado(s)`}
              </span>
            </div>
            <button 
              className="btn-primary"
              onClick={() => setShowForm(true)}
            >
              <FaPlus /> Cadastrar Classificação
            </button>
          </div>

          <div className="table-wrapper">
            <table className="data-table nucleos-table classificacao-enquadramento-table">
              <thead>
                <tr>
                  <th className="col-id">ID</th>
                  <th className="col-nome">Classificação Enquadramento</th>
                  <th className="col-nome">REF</th>
                  <th className="col-sigla">Sigla</th>
                  <th className="col-status">Status</th>
                  <th className="col-acoes">Ações</th>
                </tr>
              </thead>
              <tbody>
                {filteredClassificacoesEnquadramento.map(classificacao => (
                  <tr key={classificacao.id}>
                    <td className="col-id">{classificacao.id}</td>
                    <td className="col-nome">{classificacao.classificacao_enquadramento}</td>
                    <td className="col-nome">{classificacao.orgao_referencia || ''}</td>
                    <td className="col-sigla">
                      {classificacao.sigla && (
                        <span className="sigla-badge">{classificacao.sigla}</span>
                      )}
                     </td>
                    <td className="col-status status-cell">
                      <div className="status-toggle-wrapper">
                        <Toggle
                          checked={classificacao.ativo}
                          onChange={() => handleToggleStatus(classificacao.id)}
                          id={`toggle-${classificacao.id}`}
                        />
                      </div>
                    </td>
                    <td className="col-acoes acoes-col">
                      <div className="action-buttons">
                        <button 
                          className="btn-edit"
                          onClick={() => handleEdit(classificacao)}
                          title="Editar"
                        >
                          <FaEdit />
                        </button>
                        <button 
                          className="btn-delete"
                          onClick={() => handleDelete(classificacao.id)}
                          title="Excluir"
                        >
                          <FaTrash />
                        </button>
                      </div>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
            
            {filteredClassificacoesEnquadramento.length === 0 && !loading && (
              <div className="empty-state">
                <div className="empty-state-icon">
                  <FaSearch size={32} />
                </div>
                <h3>Nenhuma classificação de enquadramento encontrada</h3>
                <p>Tente ajustar os filtros de pesquisa ou cadastre uma nova classificação de enquadramento.</p>
              </div>
            )}
          </div>
        </div>
      )}
    </div>
  );
};

export default ClassificacaoEnquadramento;
